export const environment = {
  production: false,
  EXPIRATION_SESSION: 60 * 60 * 2, //2 hours

  CustomerID: 'lobomex',
  CustomerTitle: 'DEMO',
  API_URL: 'https://lobomexapi-demo.hersotek.com/api',
  // API_URL: 'http://localhost:39801/api',
  BLOB_URL: 'https://hersotekdev.blob.core.windows.net'
};
